import { Controller } from '@hotwired/stimulus';
import { slideToggle } from '../helpers';

export default class extends Controller {
    static get targets () {
        return ['tab', 'item'];
    }

    tabTargetConnected(element) {
        element.addEventListener('click', () => {
            const target = document.querySelector(`#${element.dataset.target}`);

            if (target) {
                this.tabTargets.forEach(tab => {
                    tab.classList.remove('active');
                });

                this.element.querySelectorAll('.accordion-list').forEach(accordion => {
                    accordion.style.display = 'none';
                });

                slideToggle(target);
                element.classList.toggle('active');
            }
        });
    }

    itemTargetConnected(element) {
        const toggle = element.querySelector('.accordion-head');
        toggle.addEventListener('click', () => {
            slideToggle(element.querySelector('.accordion-body'));
            element.classList.toggle('active');
        });
    }
}